import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';

const router = routerMiddleware(browserHistory);

export default function configureStore() {
  const store = createStore(
    rootReducer,
    applyMiddleware(thunk, router)
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js